import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
});

export const getPlatformStats = async () => {
  try {
    const response = await api.get('/stats');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch platform stats:', error);
    return {
      success: false,
      data: { hotels: 0, properties: 0, providers: 0 }
    };
  }
};
